import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";


const updateVariableSource = async ({ formFields, file }) => {
  const user = getUserDetails();

  const formData = new FormData();
  if (file) {
    formData.append("file", file);
  }
  const jsonPart = new Blob([JSON.stringify(formFields || {})], { type: "application/json" });
  formData.append("body", jsonPart);

  const url = `${API_BACKEND_URL}/environment/updateSource?companyId=${user.companyid}`;
  const response = await axios.put(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

const useUpdateVariableSource = (options = {}) => {
  return useMutation({
    mutationFn: updateVariableSource,
    ...options,
  });
};

export default useUpdateVariableSource;


